import React, { useEffect, useState } from "react";
import style from "./Detective.module.css";

import { bodyFetch } from "../../api/api";
import { useTitle } from "../../App";
import { consultInitData } from "./data";

import Header from "../../components/Header";
import Title from "../../components/Title";
import FileInput from "../../components/FileInput";
import Evidence from "../../components/detectiveCase/Evidence";
import Investigation from "../../components/detectiveCase/Investigation";

function Detective() {
  useTitle("대륜 형사 진술서");

  const sendApiUrl = process.env.REACT_APP_SEND_API_URL;
  const [tab, setTab] = useState("one");
  const [showFiles, setShowFiles] = useState([]);

  // 복사 삭제 가능한 컴포넌트
  // init = localStorage 값 있으면 받아오기
  const checkLocalStorage = (key_name) => {
    let value;

    if (key_name === "evidence") {
      value = [{ case: "", content: "", obtain: "" }];
    } else if (key_name === "investigation") {
      value = [{ date: "", agency: "", content: "", evidence: "" }];
    }
    return JSON.parse(localStorage.getItem(key_name)) || value;
  };

  const [evidence, setEvidence] = useState(checkLocalStorage("evidence"));
  const [investigation, setInvestigation] = useState(
    checkLocalStorage("investigation")
  );

  // 설문 응답 결과 state
  const [consult, setConsult] = useState(consultInitData);

  useEffect(() => {
    setConsultWithArray();
  }, []);

  //제출 후 초기화
  const resetConsult = () => {
    const newConsult = [...consult];

    for (let i = 0; i < newConsult.length; i++) {
      if (newConsult[i].key === "evidence") {
        newConsult[i].answer = [{ case: "", content: "", obtain: "" }];
      } else if (newConsult[i].key === "investigation") {
        newConsult[i].answer = [
          { date: "", agency: "", content: "", evidence: "" },
        ];
      } else if (
        ["evidence_file", "investigation_file"].includes(newConsult[i].key)
      ) {
        newConsult[i].answer = [""];
      } else {
        newConsult[i].answer = "";
      }
    }

    setConsult(newConsult);
    setEvidence([{ case: "", content: "", obtain: "" }]);
    setInvestigation([{ date: "", agency: "", content: "", evidence: "" }]);
    setShowFiles([]);
  };

  const setConsultWithArray = () => {
    const newConsult = [...consult];

    for (let i = 0; i < newConsult.length; i++) {
      if (localStorage.getItem(newConsult[i].key) !== null) {
        newConsult[i].answer = JSON.parse(
          localStorage.getItem(newConsult[i].key)
        );
      }
    }
    setConsult(newConsult);
  };

  const beforeStep = () => {
    // if(!consultCheck(tab)){
    //   return false;
    // }

    const newConsult = [...consult];

    if (tab === "three") {
      setTab("investigation");
    } else if (tab === "investigation") {
      setTab("evidence");
    } else if (tab === "evidence") {
      setTab("one");
    } else {
      setTab("");
    }
    setConsult(newConsult);
  };

  const nextStep = () => {
    if (!consultCheck(tab)) {
      return false;
    }

    if (tab === "one") {
      setTab("evidence");
    } else if (tab === "evidence") {
      setTab("investigation");
    } else if (tab === "investigation") {
      setTab("three");
    } else {
      setTab("");
    }
  };

  //반드시 입력해주세요, 숫자만 입력해주세요
  const consultCheck = () => {
    if (
      consult.filter((e) => e.key === "info_name")[0].answer.length === 0 &&
      tab === "one"
    ) {
      alert("의뢰인의 성함을 입력하세요.");
      return false;
    } else if (
      consult.filter((e) => e.key === "info_tel")[0].answer.length === 0 &&
      tab === "one"
    ) {
      alert("의뢰인의 연락처를 입력하세요.");
      return false;
    }
    // else if ((consult.filter((e) => e.key === "info_case")[0].answer.length === 0) && tab === "one") {
    //   alert("사건명을 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "detail_occurred")[0].answer.length === 0) && tab === "one") {
    //   alert("사건 발생 경위를 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "current_situation")[0].answer.length === 0) && tab === "three") {
    //   alert("현재 상황 및 변호인에 대한 요청 사항을 입력하세요.");
    //   return false;
    // }
    return true;
  };

  const consultCheck2 = () => {
    if (!consultCheck()) {
      return false;
    }

    // return setConsultResult(true);
    // consult에 설명 붙인 값으로 전달하기

    const submitConsult = [...consult];
    const findIndex = (key) => consult.findIndex((data) => data.key === key);

    for (
      let i = 0;
      i < submitConsult[findIndex("evidence")].answer.length;
      i++
    ) {
      let newAnswer = { case: "", content: "", obtain: "" };
      newAnswer.case = `자료명: ${
        submitConsult[findIndex("evidence")].answer[i].case
      }`;
      newAnswer.content = `내용 (사건 관련성): ${
        submitConsult[findIndex("evidence")].answer[i].content
      }`;
      newAnswer.obtain = `취득 경위: ${
        submitConsult[findIndex("evidence")].answer[i].obtain
      }`;
      submitConsult[findIndex("evidence")].answer[i] = newAnswer;
    }

    for (
      let i = 0;
      i < submitConsult[findIndex("investigation")].answer.length;
      i++
    ) {
      let newAnswer = { date: "", agency: "", content: "", evidence: "" };
      newAnswer.date = `일자: ${
        submitConsult[findIndex("investigation")].answer[i].date
      }`;
      newAnswer.agency = `수사기관: ${
        submitConsult[findIndex("investigation")].answer[i].agency
      }`;
      newAnswer.content = `조사내용: ${
        submitConsult[findIndex("investigation")].answer[i].content
      }`;
      newAnswer.evidence = `제출자료: ${
        submitConsult[findIndex("investigation")].answer[i].evidence
      }`;
      submitConsult[findIndex("investigation")].answer[i] = newAnswer;
    }

    const newFileAnswer = (key_name) => {
      for (
        let i = 0;
        i < submitConsult[findIndex(key_name)].answer.length;
        i++
      ) {
        let newAnswer = { name: "", url: "" };
        newAnswer.name = `증거자료 파일명: ${
          submitConsult[findIndex(key_name)].answer[i].name
        }`;
        newAnswer.url = `증거자료 파일 링크: <a href="${
          submitConsult[findIndex(key_name)].answer[i].url
        }" target="_blank">다운로드</a>`;
        submitConsult[findIndex(key_name)].answer[i] = newAnswer;
      }
      return submitConsult[findIndex(key_name)].answer;
    };
    newFileAnswer("evidence_file");
    newFileAnswer("investigation_file");

    if (window.confirm("제출하시겠습니까?")) {
      bodyFetch(
        sendApiUrl,
        {
          statement: submitConsult,
          litigation_name: "형사 진술서",
          customer_name: submitConsult[findIndex("info_name")].answer,
          case_name: submitConsult[findIndex("info_case")].answer,
          tel: submitConsult[findIndex("info_tel")].answer,
        },
        (obj) => {
          if (obj.result) {
            console.log("SUCCESS :: 진술서가 제출되었습니다.");
          } else {
            alert("전송 실패. 다시 시도해주세요");
          }
        },
        "POST"
      );

      alert("제출되었습니다.");
      localStorage.clear();
      setTab("one");
      resetConsult();
    } else {
      alert("제출이 취소되었습니다.");
    }
  };

  const handleInput = (e) => {
    e.preventDefault();
    const newConsult = [...consult];
    const newEvidence = [...evidence];
    const newInvestigation = [...investigation];

    if (e.currentTarget.name === "info_name") {
      newConsult.filter((e) => e.key === "info_name")[0].answer =
        e.currentTarget.value;
    } else if (e.currentTarget.name === "info_tel") {
      newConsult.filter((e) => e.key === "info_tel")[0].answer =
        e.currentTarget.value;
    } else if (e.currentTarget.name === "info_case") {
      newConsult.filter((e) => e.key === "info_case")[0].answer =
        e.currentTarget.value;
    } else if (e.currentTarget.name === "detail_occurred") {
      newConsult.filter((e) => e.key === "detail_occurred")[0].answer =
        e.currentTarget.value;
    } else if (e.currentTarget.name === "evidence_case") {
      newConsult
        .filter((e) => e.key === "evidence")[0]
        .answer.map((item, index) => {
          if (Number(e.currentTarget.dataset.index) === index) {
            item.case = e.currentTarget.value;
          }
          return item;
        });

      newEvidence.map((item, index) => {
        if (Number(e.currentTarget.dataset.index) === index) {
          item.case = e.currentTarget.value;
        }
        return item;
      });
    } else if (e.currentTarget.name === "evidence_content") {
      newConsult
        .filter((e) => e.key === "evidence")[0]
        .answer.map((item, index) => {
          if (Number(e.currentTarget.dataset.index) === index) {
            item.content = e.currentTarget.value;
          }
          return item;
        });

      newEvidence.map((item, index) => {
        if (Number(e.currentTarget.dataset.index) === index) {
          item.content = e.currentTarget.value;
        }
        return item;
      });
    } else if (e.currentTarget.name === "evidence_obtain") {
      newConsult
        .filter((e) => e.key === "evidence")[0]
        .answer.map((item, index) => {
          if (Number(e.currentTarget.dataset.index) === index) {
            item.obtain = e.currentTarget.value;
          }
          return item;
        });

      newEvidence.map((item, index) => {
        if (Number(e.currentTarget.dataset.index) === index) {
          item.obtain = e.currentTarget.value;
        }
        return item;
      });
    } else if (e.currentTarget.name === "evidence_file") {
      newConsult.filter((e) => e.key === "evidence_file")[0].answer = showFiles;
    } else if (e.currentTarget.name === "investigation_date") {
      newConsult
        .filter((e) => e.key === "investigation")[0]
        .answer.map((item, index) => {
          if (Number(e.currentTarget.dataset.index) === index) {
            item.date = e.currentTarget.value;
          }
          return item;
        });

      newInvestigation.map((item, index) => {
        if (Number(e.currentTarget.dataset.index) === index) {
          item.date = e.currentTarget.value;
        }
        return item;
      });
    } else if (e.currentTarget.name === "investigation_agency") {
      newConsult
        .filter((e) => e.key === "investigation")[0]
        .answer.map((item, index) => {
          if (Number(e.currentTarget.dataset.index) === index) {
            item.agency = e.currentTarget.value;
          }
          return item;
        });

      newInvestigation.map((item, index) => {
        if (Number(e.currentTarget.dataset.index) === index) {
          item.agency = e.currentTarget.value;
        }
        return item;
      });
    } else if (e.currentTarget.name === "investigation_content") {
      newConsult
        .filter((e) => e.key === "investigation")[0]
        .answer.map((item, index) => {
          if (Number(e.currentTarget.dataset.index) === index) {
            item.content = e.currentTarget.value;
          }
          return item;
        });

      newInvestigation.map((item, index) => {
        if (Number(e.currentTarget.dataset.index) === index) {
          item.content = e.currentTarget.value;
        }
        return item;
      });
    } else if (e.currentTarget.name === "investigation_evidence") {
      newConsult
        .filter((e) => e.key === "investigation")[0]
        .answer.map((item, index) => {
          if (Number(e.currentTarget.dataset.index) === index) {
            item.evidence = e.currentTarget.value;
          }
          return item;
        });

      newInvestigation.map((item, index) => {
        if (Number(e.currentTarget.dataset.index) === index) {
          item.evidence = e.currentTarget.value;
        }
        return item;
      });
    } else if (e.currentTarget.name === "investigation_file") {
      newConsult.filter((e) => e.key === "investigation_file")[0].answer =
        showFiles;
    } else if (e.currentTarget.name === "current_situation") {
      newConsult.filter((e) => e.key === "current_situation")[0].answer =
        e.currentTarget.value;
    } else if (e.currentTarget.name === "etc") {
      newConsult.filter((e) => e.key === "etc")[0].answer =
        e.currentTarget.value;
    }

    postLocalStorage();
    setConsult(newConsult);
    setEvidence(newEvidence);
    setInvestigation(newInvestigation);
  };

  // 아이템 추가
  const handleAddItem = (key) => {
    const newConsult = [...consult];
    const findIndex = consult.findIndex((data) => data.key === key);

    switch (key) {
      case "evidence":
        newConsult[findIndex].answer = [
          { case: "", content: "", obtain: "" },
          ...newConsult[findIndex].answer,
        ];
        setEvidence([{ case: "", content: "", obtain: "" }, ...evidence]);
        break;

      case "investigation":
        newConsult[findIndex].answer = [
          { date: "", agency: "", content: "", evidence: "" },
          ...newConsult[findIndex].answer,
        ];
        setInvestigation([
          { date: "", agency: "", content: "", evidence: "" },
          ...investigation,
        ]);
        break;

      default:
    }
    setConsult(newConsult);
  };

  const handleDeleteItem = (key) => {
    const newConsult = [...consult];
    const findIndex = consult.findIndex((data) => data.key === key);
    switch (key) {
      case "evidence":
        newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1);
        setEvidence(evidence.slice(1));
        break;

      case "investigation":
        newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1);
        setInvestigation(investigation.slice(1));
        break;

      default:
    }
    setConsult(newConsult);
  };

  // localStorage를 state로 바로 꺼내쓰기 어려움
  useEffect(() => {
    const newConsult = [...consult];

    newConsult.filter((e) => e.key === "evidence_file")[0].answer =
      showFiles.filter((data) => data.key === "evidence");
    newConsult.filter((e) => e.key === "investigation_file")[0].answer =
      showFiles.filter((data) => data.key === "investigation");
  }, [consult]);

  const getLocalStorage = (key_name) =>
    JSON.parse(localStorage.getItem(key_name));

  const getShowFiles = (data) => {
    setShowFiles(data);
  };

  const postLocalStorage = () => {
    for (let i = 0; i < consult.length; i++) {
      const inputValue = JSON.stringify(consult[i].answer);
      localStorage.setItem(consult[i].key, inputValue);
    }

    localStorage.setItem("evidence", JSON.stringify(evidence));
    localStorage.setItem("investigation", JSON.stringify(investigation));
  };

  return (
    <>
      <Header />
      <Title title={"형사"} />

      {tab === "one" ? (
        <>
          {/* 1. 기초사항 */}
          <section>
            <p className={style.main_tit}>1. 기초사항</p>
            {/* <p className={style.h2}></p> */}

            <div className={style.item_input_text}>
              <p className={style.tit}>성함</p>
              <input
                type="text"
                name="info_name"
                placeholder="예) 홍길동"
                value={consult.filter((e) => e.key === "info_name")[0].answer}
                onChange={handleInput}
              />
            </div>

            <div className={style.item_input_text}>
              <p className={style.tit}>연락처</p>
              <input
                type="text"
                name="info_tel"
                placeholder="예) 01012345678"
                value={consult.filter((e) => e.key === "info_tel")[0].answer}
                onChange={handleInput}
              />
            </div>

            <div className={style.item_input_text}>
              <p className={style.tit}>사건명</p>
              <input
                type="text"
                name="info_case"
                placeholder="대출사기"
                value={consult.filter((e) => e.key === "info_case")[0].answer}
                onChange={handleInput}
              />
            </div>
          </section>

          {/* 2. 사건발생경위 */}
          <section>
            <p className={style.main_tit}>2. 사건발생경위</p>
            <p className={style.tit_desc}>
              발생한 사건 내용을 시간 순으로 가능한 육하원칙에 따라 상세히
              기재하여 주시기 바랍니다. 일시는 정확한 일시가 기억나지 않으면
              기억나는 만큼 기재하여 주시면 됩니다(ex. 2022. 9. 중순경).
            </p>

            <div className={style.item_input_textarea}>
              <textarea
                name="detail_occurred"
                value={
                  consult.filter((e) => e.key === "detail_occurred")[0].answer
                }
                onChange={handleInput}
              />
            </div>
          </section>
        </>
      ) : null}

      {tab === "evidence" ? (
        <>
          {/* 3. 사건관련자료 */}
          <section>
            <p className={style.main_tit}>3. 사건관련자료</p>
            <p className={style.tit_desc}>
              발생한 사건에 관하여, 증거 기타 소지하고 있는 관련 자료가 있다면
              자료명, 내용(사건과의 관련성), 취득 경위를 기억나는 만큼만
              기재하여 주시기 바랍니다.
            </p>

            <div className={style.add_box_wrapper}>
              <p className={style.h2}>의뢰인</p>
              <div className={style.btn_box}>
                <div
                  className={style.btn}
                  onClick={() => handleDeleteItem("evidence")}
                >
                  <img src="images/btn_delete.webp" alt="삭제 버튼" />
                </div>
                <div
                  className={style.btn}
                  onClick={() => handleAddItem("evidence")}
                >
                  <img src="images/btn_plus.webp" alt="추가 버튼" />
                </div>
              </div>

              {evidence.map((item, index) => (
                <Evidence
                  key={index}
                  index={index}
                  key_name={"evidence"}
                  handleInput={handleInput}
                  getLocalStorage={getLocalStorage}
                  data={item}
                />
              ))}

              <FileInput
                tab={tab}
                consult={consult}
                handleInput={handleInput}
                showFiles={showFiles}
                getShowFiles={getShowFiles}
              />
            </div>
          </section>
        </>
      ) : null}

      {tab === "investigation" ? (
        <>
          {/* 4. 수사기관 조사 내용 */}
          <section>
            <p className={style.main_tit}>4. 수사기관 조사 내용</p>
            <p className={style.tit_desc}>
              <span className={style.red_bold}>
                (선임 전 수사기관에서 조사를 받은 경우)
              </span>
            </p>
            <p className={style.tit_desc}>
              선임 전 수사기관에서 조사를 받으신 경우, 언제 어느 수사기관에서
              어떠한 경위로 조사를 받으셨고 어떠한 내용으로 조사가 진행되었는지,
              경찰에 제출한 자료가 있다면 어떠한 자료를 제출하였는지 구체적으로
              적어주시기 바랍니다.
            </p>

            <div className={style.add_box_wrapper}>
              <p className={style.h2}>의뢰인</p>
              <div className={style.btn_box}>
                <div
                  className={style.btn}
                  onClick={() => handleDeleteItem("investigation")}
                >
                  <img src="images/btn_delete.webp" alt="삭제 버튼" />
                </div>
                <div
                  className={style.btn}
                  onClick={() => handleAddItem("investigation")}
                >
                  <img src="images/btn_plus.webp" alt="추가 버튼" />
                </div>
              </div>

              {investigation.map((item, index) => (
                <Investigation
                  key={index}
                  index={index}
                  key_name={"investigation"}
                  handleInput={handleInput}
                  getLocalStorage={getLocalStorage}
                  data={item}
                />
              ))}

              <FileInput
                tab={tab}
                consult={consult}
                handleInput={handleInput}
                showFiles={showFiles}
                getShowFiles={getShowFiles}
              />
            </div>
          </section>
        </>
      ) : null}

      {tab === "three" ? (
        <>
          {/* 5. 현재 상황 및 변호인에 대한 요청 사항*/}
          <section>
            <p className={style.main_tit}>
              5. 현재 상황 및 변호인에 대한 요청 사항
            </p>
            <p className={style.tit_desc}>
              사건 발생 이후부터 현재까지 진행된 사항 기타 특이사항, 사건 진행에
              있어 요청하고 싶으신 부분, 현재 상대방(피해자, 가해자)과의 관계
              등을 기재하여 주시기 바랍니다.
            </p>

            <div className={style.item_input_text}>
              <div className={style.item_input_textarea}>
                <textarea
                  name="current_situation"
                  value={
                    consult.filter((e) => e.key === "current_situation")[0]
                      .answer
                  }
                  onChange={handleInput}
                />
              </div>
            </div>
          </section>

          {/* 6. 기타 자유기재*/}
          <section>
            <p className={style.main_tit}>6. 기타 자유기재</p>
            <p className={style.tit_desc}>
              나이, 거주지, 직업, 가족관계, 경제적상황, 성장배경, 삶의 꿈과
              계획, 기타 사항을 자유롭게 기재하여 주시기 바랍니다.
            </p>

            <div className={style.item_input_text}>
              <div className={style.item_input_textarea}>
                <textarea
                  name="etc"
                  placeholder=""
                  value={consult.filter((e) => e.key === "etc")[0].answer}
                  onChange={handleInput}
                />
              </div>
            </div>

            <div className={style.tit_wrapper}>
              <div className={style.desc}>
                <p className={style.sub}>
                  맡겨주신 사건, 최선의 결과로 보답하겠습니다.
                </p>
                <p className={style.title}>
                  법무법인 대륜 <span>1800-7905</span>
                </p>
                <p className={style.email}>대표메일 law@daeryunlaw.com</p>
              </div>
            </div>
          </section>
        </>
      ) : null}

      {/* 하단 버튼 */}
      {tab === "one" ? (
        <div className={style.btn_wrapper_1} onClick={nextStep}>
          <div className={style.start_btn}>다음</div>
        </div>
      ) : tab === "three" ? (
        <div className={style.btn_wrapper_2}>
          <div className={style.before_btn} onClick={beforeStep}>
            이전
          </div>
          <div className={style.finish_btn} onClick={consultCheck2}>
            완료
          </div>
        </div>
      ) : (
        <div className={style.btn_wrapper_2}>
          <div className={style.before_btn} onClick={beforeStep}>
            이전
          </div>
          <div className={style.start_btn} onClick={nextStep}>
            다음
          </div>
        </div>
      )}
    </>
  );
}

export default Detective;
